import React from "react";

function loading() {
  return (
    <div
      style={{
        height: "80vh",
      }}
    >
      <div
        className="lds-ripple overlay"
        style={{
          marging: "0 auto",
          left: "calc(50% - 15px)",
          top: "calc(50% - 15px)",
        }}
      >
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default loading;
